import { ITagsSchema } from './tags-schema.interface';
import { IZoneSchema } from './zone-schema.interface';

export interface ILocationSchema {
    id: string;
    organizationId?: string;
    name: string;
    isWarehouse?: boolean;
    code: string;
    externalId?: string | null;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    country?: string;
    latitude?: string;
    longitude?: string;
    zones?: string[] | IZoneSchema[];
    tags?: string[] | ITagsSchema[];
    contactEmail?: string;
    contactPhone?: string;
    status?: string;
    createdAt?: string;
    updatedAt?: string;
}
